import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}dtac-game`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const dtacGamingApi = {
  postSendReceipt: (request) => {
    // page_id
    // order_id
    const { data } = request
    return instance().post(`/send-receipt`, data)
  },
  syncGames: (request) => {
    const { data } = request
    return instance().post(`/sync-games`, data, {
      baseURL: `${config.serverUrl}api/gaming-nation-cns`
    })
  },
  getGamesCode: (pageId, page) => {
    return instance().get(`/games-code/page?page_id=${pageId}&page=${page}`, {
      baseURL: `${config.serverUrl}api/gaming-nation-cns`
    })
  },
  getGamesCodeSku: (pageId, code) => {
    return instance().get(`/game-code?page_id=${pageId}&code=${code}`, {
      baseURL: `${config.serverUrl}api/gaming-nation-cns`
    })
  }
}

export default dtacGamingApi



// WEBPACK FOOTER //
// ./src/api/dtac-gaming.js